/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Header from "./header"
import "./layout.css"

interface LayoutProps {
  children: JSX.Element | JSX.Element[];
}

const Layout = ({ children }: LayoutProps) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: `var(--size-content)`,
          padding: `var(--size-header-gap) var(--size-gutter) var(--size-gutter) var(--size-gutter)`,
        }}
      >
        <main>{children}</main>
      </div>
      <footer className="shubhi-footer">
        <div className="social-links">
          <a href="https://linkedin.com/in/shubhis/" title="LinkedIn" target="_blank" rel="noopener noreferrer">
            <StaticImage src="../images/ico/linkedin-icon.png" width={32} height={32} alt="LinkedIn" />
          </a>
          <a href="https://instagram.com/s.shubhiz/" title="Instagram" target="_blank" rel="noopener noreferrer">
            <StaticImage src="../images/ico/instagram-icon.png" width={32} height={32} alt="Instagram" />
          </a>
        </div>
        <div className="flex-center">
          © {new Date().getFullYear()} &middot; ShubhiDesigns.com | Site By&nbsp;
          <a href="https://lampi.dev" target="_blank" rel="noopener noreferrer">
            Nathan Lampi
          </a>
        </div>
      </footer>
    </>
  )
}

export default Layout
